var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid grid--full-height", attrs: { id: "error-layout" } },
    [
      _c(
        "div",
        {
          staticClass:
            "grid__cell grid grid--column grid--jc-middle grid--ai-middle"
        },
        [
          _c("div", { staticClass: "error__wrapper" }, [
            _vm.showMaLogo
              ? _c("img", {
                  staticClass: "mg mg--b-2",
                  attrs: { src: require("@/assets/logo_ma_orange.svg") }
                })
              : _vm._e(),
            !_vm.showMaLogo
              ? _c("img", {
                  staticClass: "mg mg--b-2",
                  attrs: { src: require("@/assets/logo_gen.svg") }
                })
              : _vm._e(),
            _c("p", { staticClass: "headline-large mg mg--b-1 gray" }, [
              _vm._v(_vm._s(_vm.errorTitle))
            ]),
            _c("p", { staticClass: "text-medium mg mg--b-4 gray" }, [
              _vm._v(_vm._s(_vm.$t("error.text")))
            ]),
            _c(
              "button",
              {
                staticClass: "mainBlue",
                on: {
                  click: function($event) {
                    return _vm.routerBack()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("error.btn")))]
            )
          ])
        ]
      ),
      _c("div", { staticClass: "grid__cell" }, [
        _c("div", {
          staticClass: "error__bg",
          style: {
            backgroundImage:
              "url(" +
              require("@/assets/images/views/error/error_bg_1x.png") +
              ")"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }